import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

export default function SetActiveAccount() {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (!instance.getActiveAccount() && accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [instance, accounts]);

  return null;
}